import styled from 'styled-components'

import { style } from 'theme'
import { TextInputV3 } from '@acorns/web-components'
import { theme } from '@acorns/grove'

export const HeroHeader = styled.div`
  margin: 0px auto 30px;
  max-width: 340px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
    font-size: 30px;
    line-height 41px;
    text-align: center;
  }
  @media (min-width: ${style((theme) => theme.breakpoints.sm)}px) {
    font-size: 30px;
    line-height: 41px;
    text-align: center;
  }
`

export const StyledText = styled.p`
  white-space: pre-wrap;
  font-weight: bold;
  text-align: center;
  margin: 0;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-top: 0;
  }
`

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const FormItem = styled.div`
  width: 100%;
  flex-basis: 100%;

  .text-input {
    width: 100%;
  }
`

export const StyledTextInput = styled(TextInputV3)`
  input {
    max-width: 100%;
  }

  input:disabled {
    opacity: 1;
  }
`

export const LoginText = styled.div`
  font-size: 14px;
  line-height: 22px;
  font-weight: ${theme.fontWeight.demiBold};
  margin-top: 37px;
  text-align: center;
  a {
    text-decoration: none !important;
  }
`

export const GetStartedButtonContainer = styled.div`
  margin-top: 20px;
`
